"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var makeStyle = function makeStyle() {
  var mainColour = '#76C100';
  var linkColour = 'rgba(0, 0, 0, 0)';
  return {
    Button: {
      padding: '6px 12px',
      '& .left': {
        display: 'flex',
        flexDirection: 'row'
      },
      '&.btn-success': {
        backgroundColor: "".concat(mainColour),
        border: "1px solid ".concat(mainColour)
      },
      '&.btn-link': {
        backgroundColor: "".concat(linkColour, " !important"),
        border: "1px solid ".concat(linkColour, " !important"),
        '&.ripple:active': {
          backgroundColor: "".concat(linkColour, " !important")
        }
      },
      '&.ripple': {
        pointerEvents: 'click',
        position: 'relative',
        overflow: 'hidden',
        transform: 'translate3d(0, 0, 0)'
      },
      '&.ripple:focus': {
        outline: '0 !important',
        boxShadow: 'none !important'
      },
      '&.ripple:after': {
        content: '\'\'',
        display: 'block',
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: '0',
        left: '0',
        pointerEvents: 'none',
        backgroundImage: 'radial-gradient(circle, #000 10%, transparent 10.01%)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50%',
        transform: 'scale(10,10)',
        opacity: '0',
        transition: 'transform .2s, opacity 0.7s'
      },
      '&.ripple:active:after': {
        transform: 'scale(0,0)',
        opacity: '.2',
        transition: '0s'
      }
    }
  };
};

var _default = makeStyle;
exports["default"] = _default;
//# sourceMappingURL=style.js.map